import userReducer from './';

export default userReducer;
